import { render, staticRenderFns } from "./NewsCenterIndex.vue?vue&type=template&id=0d30ae82&scoped=true&"
import script from "./NewsCenterIndex.vue?vue&type=script&lang=js&"
export * from "./NewsCenterIndex.vue?vue&type=script&lang=js&"
import style0 from "./NewsCenterIndex.vue?vue&type=style&index=0&id=0d30ae82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d30ae82",
  null
  
)

export default component.exports